angular
  .module('contrast.services.auth.config', [])
  .factory('AuthConfigService', function (Blob, FileSaver) {
    'ngInject'

    return {
      downloadTestError: downloadTestError,
      getADConnectionFields: getADConnectionFields,
      getADLoginFields: getADLoginFields,
      setFieldsPristine: setFieldsPristine,
      areFieldsDirty: areFieldsDirty,
      downloadSAMLTestError: downloadSAMLTestError
    }

    function downloadTestError(testError, fileName) {
      var errorText = ''

      errorText += 'Time Elapsed: ' + testError.timeElapsed + ' s\r\n\r\n'
      errorText += 'Error Message: ' + testError.message + '\r\n\r\n'
      errorText += 'Exception: ' + testError.exception

      downloadFile(errorText, fileName)
    }

    function downloadSAMLTestError(testErrors, fileName) {
      var errorText = ''
      for (var i = 0; i < testErrors.length; i++) {
        if (errorText != '') {
          errorText += '\r\n\r\n'
        }
        errorText += testErrors[i]
      }

      downloadFile(errorText, fileName)
    }

    function downloadFile(text, fileName) {
      var data = new Blob([text], { type: 'text/plain;charset=utf-8' })
      FileSaver.saveAs(data, fileName, true)
    }

    function getADConnectionFields() {
      return [
        'adUsername',
        'adPassword',
        'adProtocol',
        'adHost',
        'adPort',
        'adBase'
      ]
    }

    function getADLoginFields() {
      return [
        'adUsername',
        'adPassword',
        'adProtocol',
        'adHost',
        'adPort',
        'adBase',
        'adUserDnSuffix',
        'adIdentityAttrName',
        'adFollowReferrals',
        'adLimitReferrals',
        'adNestedGroups',
        'adGroupUsers',
        'adGroupAdmin'
      ]
    }

    function setFieldsPristine(form, fieldNames) {
      for (var i = 0; i < fieldNames.length; i++) {
        form[fieldNames[i]].$setPristine()
      }
    }

    function areFieldsDirty(form, fieldNames) {
      for (var i = 0; i < fieldNames.length; i++) {
        if (form[fieldNames[i]].$dirty) {
          return true
        }
      }
      return false
    }
  })
